const cleanString = (str?: string) => (str ? str.replace(/(\r\n|\n|\r)/gm, '') : '');

const formatNum = (num: number) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export { cleanString, formatNum };
